const CONTRIBUTOR_TAG_COLORS = [
  'color-disabled',
  'color-hover',
  'color-blue',
  'color-beige-dark',
  'color-blue-dark-40',
  'color-blue-light',
  'color-yellow-80',
  'color-red-20',
  'color-focus',
  'color-green-dark-15',
  'color-yellow',
  'color-focus',
  'color-green-40',
  'color-blue-dark-15',
  'color-yellow-50',
  'color-green',
  'color-red',
];

export default CONTRIBUTOR_TAG_COLORS;
